import { render, staticRenderFns } from "./Marquee.vue?vue&type=template&id=2a580c3c&scoped=true"
import script from "./Marquee.vue?vue&type=script&lang=js"
export * from "./Marquee.vue?vue&type=script&lang=js"
import style0 from "./Marquee.vue?vue&type=style&index=0&id=2a580c3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a580c3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a580c3c')) {
      api.createRecord('2a580c3c', component.options)
    } else {
      api.reload('2a580c3c', component.options)
    }
    module.hot.accept("./Marquee.vue?vue&type=template&id=2a580c3c&scoped=true", function () {
      api.rerender('2a580c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/Marquee.vue"
export default component.exports